/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { useAuth } from "../../../context/Auth/AuthProvider";
import { USER_PERMISSIONS } from "../../../roles/types/enums";
import { useMediaQueries } from "../../../shared";
import { useStyles } from "../styles";
import CCExpiration from "./CCExpiration/CCExpiration";
import Connectivity from "./Connectivity/Connectivity";
import Credits from "./Credits/Credits";
import DriverDownloads from "./ResourceDownloads/DriverDownloads/DriverDownloads";
import VehicleDownloads from "./ResourceDownloads/VehicleDownloads/VehicleDownloads";

const LeftSide = () => {
  const { getAccessStatus } = useAuth();
  const { to1099, from1099, fromLg } = useMediaQueries();

  const { leftSide, leftSidePapersHolder } = useStyles({
    to1099,
    from1099,
    fromLg
  });

  return (
    <div css={css(leftSide)}>
      {getAccessStatus(USER_PERMISSIONS.SeeCreditsDashboard) && <Credits />}

      <div css={css([leftSidePapersHolder])}>
        <DriverDownloads />
        <VehicleDownloads />
      </div>

      <div css={css([leftSidePapersHolder])}>
        <Connectivity />
        <CCExpiration />
      </div>
    </div>
  );
};

export default LeftSide;
